import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=8ceeaeea&scoped=true&"
import script from "./Department.vue?vue&type=script&lang=js&"
export * from "./Department.vue?vue&type=script&lang=js&"
import style0 from "./Department.vue?vue&type=style&index=0&id=8ceeaeea&lang=less&scoped=true&"
import style1 from "./Department.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ceeaeea",
  null
  
)

export default component.exports